/**
 * Sanitize GTIN / C-GTIN input for the Hämta field.
 * Allows digits, or a leading C/c followed by digits (max 14 chars).
 */
export function sanitizeGtinInput(raw) {
  const value = String(raw ?? '');
  if (/^c/i.test(value)) {
    return (`C${value.slice(1).replace(/\D/g, '')}`).slice(0, 14);
  }
  return value.replace(/\D/g, '').slice(0, 14);
}

/**
 * Normalize a GTIN for /products/by-gtin:
 * - Numeric: strip non-digits, left-pad to 14
 * - C-GTIN: C + digits, pad numeric part to 13 → e.g. C5022409737576
 * Returns null when invalid / empty.
 */
export function normalizeGtin(raw) {
  const trimmed = String(raw ?? '').trim();
  if (!trimmed) return null;

  if (/^c/i.test(trimmed)) {
    const digits = trimmed.slice(1).replace(/\D/g, '');
    if (!digits || digits.length > 13) return null;
    return `C${digits.padStart(13, '0')}`;
  }

  const digits = trimmed.replace(/\D/g, '');
  if (!digits || digits.length > 14) return null;
  return digits.padStart(14, '0');
}
